export const getCategoryWiseProducts = (books, genres) =>
	!genres.length
		? books
		: books.filter((book) =>
				genres.some(
					(genre) => book.genre.toUpperCase() === genre.toUpperCase()
				)
		  );
